export const MAX_FILES_UPLOAD = 30

// Full file type support (includes legacy .xls format)
export const acceptedFileTypes = {
  "application/pdf": [".pdf"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
  "text/plain": [".txt", ".prn"],
  "image/png": [".png"],
  "image/jpeg": [".jpg", ".jpeg"],
  "image/webp": [".webp"],
  "application/vnd.ms-excel": [".xls"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
  "text/csv": [".csv"],
  "application/json": [".json"],
} as const

// Azure OpenAI Files API supported formats for file uploads.
// .xls/.xlsx/.csv aren't supported for vector-store *retrieval* ("Files with
// extensions [.xlsx] are not supported for retrieval"), but the backend still
// uploads them and sends their extracted text straight to the model — it only
// skips semantic file_search indexing for that subset. So they belong here
// too, not just in the retrieval-eligible list (#2596). Other upload-only,
// non-retrieval extensions the backend also accepts (.xml, .zip, .tar) are
// intentionally left out below — they're not offered anywhere in the chat
// composer today, so adding them here alone wouldn't do anything.
export const azureOpenAIAcceptedFileTypes = {
  "application/pdf": [".pdf"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
  "application/msword": [".doc"],
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": [".pptx"],
  "text/plain": [".txt", ".prn"],
  "text/markdown": [".md"],
  "text/html": [".html"],
  "text/css": [".css"],
  "text/javascript": [".js"],
  "application/typescript": [".ts"],
  "application/json": [".json"],
  "application/vnd.ms-excel": [".xls"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
  "text/csv": [".csv"],
  "text/x-python": [".py"],
  "text/x-java": [".java"],
  "text/x-csharp": [".cs"],
  "text/x-c": [".c"],
  "text/x-c++": [".cpp"],
  "application/x-httpd-php": [".php"],
  "text/x-ruby": [".rb"],
  "text/x-go": [".go"],
  "application/x-sh": [".sh"],
  "application/x-tex": [".tex"],
  // Images are supported for vision, but not for file_search retrieval
  "image/png": [".png"],
  "image/jpeg": [".jpg", ".jpeg"],
  "image/gif": [".gif"],
  "image/webp": [".webp"],
} as const

export const acceptedFileTypesWithoutImages = Object.fromEntries(
  Object.entries(acceptedFileTypes).filter(([mimeType]) => !mimeType.startsWith("image/"))
)

export const azureOpenAIAcceptedFileTypesWithoutImages = Object.fromEntries(
  Object.entries(azureOpenAIAcceptedFileTypes).filter(
    ([mimeType]) => !mimeType.startsWith("image/")
  )
)
